/**
 * Preset Tailwind con los tokens de marca de Laburen.
 *
 * Es la única definición de los colores: `apps/web` lo extiende con
 * `presets: [require('@ops/contracts/tailwind-preset')]` y no los redeclara.
 *
 * NIVEL DE TEXTO — los colores de marca NO pasan 4,5:1 como color de letra
 * (#4CC722 da 2,21:1 · #0EA803 da 3,17:1 · #EB5757 da 3,48:1 · #F59E0B da
 * 2,15:1). Por eso hay dos familias de tokens y no se mezclan:
 *
 *   - RELLENO / punto / borde / barra: accent, accent-deep, accent-soft,
 *     danger, danger-soft, warning, warning-soft.
 *   - TEXTO: accent-text (5,32:1), danger-text (5,44:1), warning-text (7,09:1),
 *     muted-strong (5,74:1, para gris sobre los fondos *-soft).
 *
 * Sobre un relleno de marca el texto va en `text-text`, NUNCA blanco: blanco
 * sobre el verde da 2,21:1.
 */

/** Paleta cruda, por si hace falta en JS (charts de Recharts, por ejemplo). */
const colors = {
  bg: '#FAFAFA',
  surface: '#FFFFFF',
  text: '#171717',
  muted: '#737373',
  /** Gris legible sobre los fondos *-soft. 5,74:1 sobre blanco. */
  'muted-strong': '#666666',
  border: '#E5E5E5',
  n100: '#F5F5F5',
  n300: '#D4D4D4',

  accent: '#4CC722',
  'accent-deep': '#0EA803',
  'accent-soft': '#EAF9E3',
  /** Verde de marca en versión legible como letra. 5,32:1 sobre blanco. */
  'accent-text': '#0A7D02',

  danger: '#EB5757',
  'danger-soft': '#FDECEC',
  /** 5,44:1 sobre blanco. Ya existe en el deck. */
  'danger-text': '#C0392B',

  warning: '#F59E0B',
  'warning-soft': '#FEF3C7',
  /** 7,09:1 sobre blanco. */
  'warning-text': '#92400E',
}

/** Colores de los charts, derivados de los tokens. Sin paleta paralela. */
const chart = {
  serie: colors['accent-deep'],
  serieSuave: colors.accent,
  perdida: colors.danger,
  atencion: colors.warning,
  neutro: colors.n300,
  grid: colors.border,
  eje: colors['muted-strong'],
}

const shadows = {
  card: '0 4px 12px rgba(0,0,0,.06)',
  pop: '0 8px 24px rgba(0,0,0,.08)',
}

const preset = {
  theme: {
    extend: {
      colors,
      fontFamily: {
        sans: [
          'Inter Variable',
          'Inter',
          'system-ui',
          '-apple-system',
          'sans-serif',
        ],
      },
      boxShadow: shadows,
      transitionTimingFunction: {
        brand: 'cubic-bezier(0.22,1,0.36,1)',
      },
      borderRadius: {
        card: '10px',
      },
      fontSize: {
        // Herramienta interna densa: la escala arranca chica y no hay títulos
        // sobredimensionados.
        micro: ['11px', { lineHeight: '14px' }],
        meta: ['12px', { lineHeight: '16px' }],
        base: ['13px', { lineHeight: '18px' }],
        titulo: ['15px', { lineHeight: '20px' }],
        seccion: ['18px', { lineHeight: '24px' }],
        kpi: ['30px', { lineHeight: '34px', letterSpacing: '-0.02em' }],
        hero: ['56px', { lineHeight: '58px', letterSpacing: '-0.03em' }],
      },
    },
  },
  plugins: [],
}

module.exports = preset
module.exports.LABUREN_COLORS = colors
module.exports.LABUREN_CHART_COLORS = chart
module.exports.LABUREN_SHADOWS = shadows
